export const book = 'book';
